module.exports = __webpack_public_path__ + "img/kefu_icon.83b3ef15.svg";